
import type { PropType } from 'vue'
import type { AppMessages } from '../../models'

import { defineComponent } from 'vue'

import { EpbSwitch } from '../shared/epb-switch'
import InputErrors from '../shared/input-errors.component.vue'
import InputLabel from '../shared/input-label.component.vue'

export default defineComponent({
  name: 'BooleanServiceConfigField',
  components: {
    EpbSwitch,
    InputLabel,
    InputErrors,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    description: {
      type: String,
    },
    options: {
      type: Object as PropType<AppMessages['switch']>,
      default: () => undefined,
    },
    value: {
      type: Boolean,
    },
    required: {
      type: Boolean,
    },
    readonly: {
      type: Boolean,
    },
    errors: {
      type: Array as PropType<Array<string>>,
      default: () => [],
    },
  },
  data() {
    return {
      baseClass: 'epb-boolean-service-config-field',
    }
  },
  computed: {
    messages(): AppMessages['switch'] {
      return this.options || this.$epb.messages.app.switch
    },
  },
})
